new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        // Função para aguardar elemento existir
        const waitForElement = (selector, callback) => {
            const element = document.querySelector(selector);
            if (element) {
                callback(element);
            } else {
                setTimeout(() => waitForElement(selector, callback), 100);
            }
        };

        waitForElement('#faixa-cupom', (element) => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const formElement = document.querySelector('.faixa-cupom-form');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.textContent.replace(/^\/\//, '');
                    inputElement.textContent = newValueInput

                    if (formButton) {
                        console.log('Botão encontrado, adicionando event listener');
                        formButton.addEventListener("click", async (e) => {
                            e.preventDefault();
                            console.log('Botão clicado, valor a copiar:', newValueInput);

                            try {
                                // Usar a API moderna do clipboard
                                await navigator.clipboard.writeText(newValueInput);
                                console.log('Cupom copiado com sucesso!');

                                // Adicionar classe copiado no form
                                formElement.classList.add('copiado');

                                // Mudar texto do botão para "Copiado"
                                const originalText = formButton.textContent;
                                formButton.textContent = 'Copiado';

                                // Remover classe e restaurar texto após 3 segundos
                                setTimeout(() => {
                                    formElement.classList.remove('copiado');
                                    formButton.textContent = originalText;
                                }, 3000);

                            } catch (err) {
                                console.log('Erro na API moderna, usando fallback:', err);
                                // Fallback para navegadores mais antigos
                                // Criar um input temporário para copiar
                                const tempInput = document.createElement('input');
                                tempInput.value = newValueInput;
                                document.body.appendChild(tempInput);
                                tempInput.select();
                                document.execCommand("copy");
                                document.body.removeChild(tempInput);
                                window.getSelection().removeAllRanges();

                                // Adicionar classe copiado no form
                                formElement.classList.add('copiado');

                                // Mudar texto do botão para "Copiado"
                                const originalText = formButton.textContent;
                                formButton.textContent = 'Copiado';

                                // Remover classe e restaurar texto após 3 segundos
                                setTimeout(() => {
                                    formElement.classList.remove('copiado');
                                    formButton.textContent = originalText;
                                }, 3000);
                            }
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 700,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.categories').then(element => {
        $('#categories-home-carrousel').slick({
            arrows: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 2,
            speed: 700,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        rows: 1,
                        slidesPerRow: 1,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.banner-info-content').then(element => {
        $('.banner-info-content').slick({
            arrows: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        });
    });


    waitForElementToExist('.faixa-comunicado').then(element => {
        const banner = element.querySelector('#faixa-comunicado');

        if (banner) {
            $('#faixa-comunicado').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
                autoplaySpeed: 2500,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list3').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list4').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3',
                        '#carrousel-product-list4'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-vitrine.second-rotation').then(element => {
        $('#carrousel-product-list5').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list6').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list7').slick({
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list5',
                        '#carrousel-product-list6',
                        '#carrousel-product-list7'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list5, #carrousel-product-list6, #carrousel-product-list7, #carrousel-product-list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list');
        if (vitrineCarrousel) {
            $('#product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list2');
        if (vitrineCarrousel) {
            $('#product_list2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list3');
        if (vitrineCarrousel) {
            $('#product_list3').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.four-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list4');
        if (vitrineCarrousel) {
            $('#product_list4').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list4').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.five-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list5');
        if (vitrineCarrousel) {
            $('#product_list5').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.six-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list6');
        if (vitrineCarrousel) {
            $('#product_list6').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.seven-vitrine').then(element => {
        const vitrineCarrousel = element.querySelector('#product_list7');
        if (vitrineCarrousel) {
            $('#product_list7').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list7').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.she-use').then(element => {
        const banner = element.querySelector('.she-use__list');

        if (banner) {
            $('.she-use__list').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',

                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            arrows: true,
                            autoplay: false,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if (banner) {
            $('.banner-instagram__list').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 300,
                cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',

                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.banner-full').then(element => {
        $('.banner-full-content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
        });
    });



});